import React from 'react'
import styled from 'styled-components'

const BG = '#000000'
const HEADER_COLOR = '#FFFFFF'
const MESSAGE_COLOR = '#FFB800'

const Wrap = styled.section`
  background-color: ${BG};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  text-align: center;
  padding-bottom: 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.h2`
  color: ${HEADER_COLOR};
  font-weight: bold;
  font-style: italic;
  text-transform: uppercase;
  margin: 0;
  font-size: 1.3rem;
  line-height: 1.2;
  width: 100%;
  padding: 0 1em;

`

const MessageRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 16px;
  margin-top: auto;
  margin-bottom: auto;
`

const BulbIcon = styled.i.attrs({
  className: 'ion-lightbulb',
  'aria-hidden': true,
})`
  color: ${HEADER_COLOR};
  font-size: 1.25rem;
  line-height: 1;
`

const MessageText = styled.span`
  color: ${MESSAGE_COLOR};
  font-weight: bold;
  font-size: 1.1rem;
  line-height: 1.3;
  text-align: left;
`

export const PartidosQuinielaPending = ({
  title = '',
  message = '',
  className = '',
  style = {},
}) => (
  <Wrap className={className} style={style} role="status" aria-live="polite">
    <Title className="font-chivo title-quiniela sub">{title}</Title>
    <MessageRow>
      <BulbIcon />
      <MessageText>{message}</MessageText>
    </MessageRow>
  </Wrap>
)

export default PartidosQuinielaPending
